var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Item } from "../data/item";
import { PriceRule } from '../data/price-rule';
/**
 * Update items' price according to different modes
 * **/
var PriceManager = /** @class */ (function () {
    function PriceManager() {
        this.level = 1;
        this.priceRules = [];
    }
    PriceManager.prototype.getTime = function () {
        if (this.debugTime)
            return this.debugTime;
        return new Date().getTime();
    };
    PriceManager.prototype.setDebugTime = function (time) {
        this.debugTime = time;
    };
    PriceManager.prototype.pickPriceRule = function (menu, mode, member) {
        var level = 1;
        var priceRules = menu.priceRules;
        if (!priceRules) {
            return level;
        }
        var now = this.getTime();
        console.log("checking priceRules", priceRules);
        var topPr;
        var topScore = -10000;
        for (var _i = 0, priceRules_1 = priceRules; _i < priceRules_1.length; _i++) {
            var pr = priceRules_1[_i];
            var score = PriceRule.getMatch(pr, now, mode, member);
            if (score > topScore) {
                topPr = pr;
                topScore = score;
            }
            console.log("score", score, pr.name);
        }
        if (topPr) {
            level = topPr.level;
        }
        return level;
    };
    PriceManager.prototype.updateBasePrice = function (menu, mode, member) {
        console.log("updateBasePrice", mode, member);
        var newLevel = this.pickPriceRule(menu, mode, member);
        console.log("pick level", newLevel);
        if (newLevel == menu.priceLevel)
            return;
        this.level = newLevel;
        menu.priceLevel = newLevel;
        this.priceRules = menu.priceRules;
        var gmap = menu['gmap'];
        var keys = Object.keys(gmap);
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var ig = gmap[key];
            for (var _a = 0, _b = ig.items; _a < _b.length; _a++) {
                var item = _b[_a];
                var priceX = Item.getPrice(item, this.level);
                item.price = priceX;
            }
        }
    };
    PriceManager.prototype.updateMinMaxPrice = function (menu) {
        console.log("updating min max price");
        var gmap = menu['gmap'];
        if (!gmap) {
            console.log("no gmap for this menu", menu.id);
            return;
        }
        var keys = Object.keys(gmap);
        for (var _i = 0, keys_2 = keys; _i < keys_2.length; _i++) {
            var key = keys_2[_i];
            var ig = gmap[key];
            var maxPrice = null;
            var minPrice = null;
            for (var _a = 0, _b = ig.items; _a < _b.length; _a++) {
                var item = _b[_a];
                var price = item.price;
                if (maxPrice == null || price > maxPrice)
                    maxPrice = price;
                if (minPrice == null || price < minPrice)
                    minPrice = price;
            }
            if (ig.min > 0) {
                ig.minPrice = minPrice * ig.min;
                ig.maxPrice = maxPrice * ig.min;
            }
        }
        for (var _c = 0, keys_3 = keys; _c < keys_3.length; _c++) {
            var key = keys_3[_c];
            var ig = gmap[key];
            for (var _d = 0, _e = ig.items; _d < _e.length; _d++) {
                var item = _e[_d];
                if (item.groupIds && item.groupIds.length > 0) {
                    var price = item.price;
                    var minPrice = price;
                    var maxPrice = price;
                    for (var _f = 0, _g = item.groupIds; _f < _g.length; _f++) {
                        var gid = _g[_f];
                        var ig = gmap[gid];
                        if (ig) {
                            if (ig.minPrice)
                                minPrice += ig.minPrice;
                            if (ig.maxPrice)
                                maxPrice += ig.maxPrice;
                        }
                    }
                    item.minPrice = minPrice;
                    item.maxPrice = maxPrice;
                }
            }
        }
    };
    PriceManager.prototype.pickOrderMinMax = function (menu, mode, member, store) {
        var priceRules = menu.priceRules;
        if (!priceRules)
            return;
        var now = this.getTime();
        console.log("checking priceRules", priceRules);
        var topPr;
        var topScore = -10000;
        for (var _i = 0, priceRules_2 = priceRules; _i < priceRules_2.length; _i++) {
            var pr = priceRules_2[_i];
            var score = PriceRule.getMatch(pr, now, mode, member);
            if (score > topScore) {
                topPr = pr;
                topScore = score;
            }
            console.log("score", score, pr.name);
        }
        return topPr;
    };
    PriceManager = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], PriceManager);
    return PriceManager;
}());
export { PriceManager };
//# sourceMappingURL=price-manager.js.map